/* CURRENCIES */
export const GET_CURRENCIES = "GET_CURRENCIES"
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS"
export const GET_CURRENCIES_FAIL = "GET_CURRENCIES_FAIL"

/* CURRENCIES PROFILE */
export const GET_CURRENCY_PROFILE = "GET_CURRENCY_PROFILE"
export const GET_CURRENCY_PROFILE_SUCCESS = "GET_CURRENCY_PROFILE_SUCCESS"
export const GET_CURRENCY_PROFILE_FAIL = "GET_CURRENCY_PROFILE_FAIL"

/**
 * add account
 */
export const ADD_NEW_CURRENCY = "ADD_NEW_CURRENCY"
export const ADD_CURRENCY_SUCCESS = "ADD_CURRENCY_SUCCESS"
export const ADD_CURRENCY_FAIL = "ADD_CURRENCY_FAIL"

/**
 * Edit account
 */
export const UPDATE_CURRENCY = "UPDATE_CURRENCY"
export const UPDATE_CURRENCY_SUCCESS = "UPDATE_CURRENCY_SUCCESS"
export const UPDATE_CURRENCY_FAIL = "UPDATE_CURRENCY_FAIL"

/**
 * Delete account
 */
export const DELETE_CURRENCY = "DELETE_CURRENCY"
export const DELETE_CURRENCY_SUCCESS = "DELETE_CURRENCY_SUCCESS"
export const DELETE_CURRENCY_FAIL = "DELETE_CURRENCY_FAIL"
